<ycn-edit-data-columns-modal
    [submitButtonText]="'Apply'"
    [instructionText]="instructionText"
    [metricSearchType]="searchType"
    [columns]="modalColumns"
    [defaultColumns]="modalDefaultColumns"
    [maxMetricCols]="MAX_COLS"
    (submitHandler)="submitModal($event)">
</ycn-edit-data-columns-modal>
